import React, { Component, createRef } from 'react';
import ReactDOM from 'react-dom';
import Container from '../../../layouts/containers/container';
import Row from '../../../components/row';
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import dayjs from "dayjs";
import { datetimeLocalToString } from '../../../lib/helpers/datetime-helpers';
import coWorkingApi from '../../../lib/co-working/co-working-api';
import NavItem from '../nav-link';
import InputsCounter from '../../../components/inputs/inputs-counter';
import LabelContainer from '../../../components/label-container';
import List from '../../../components/list';

import { handleLinks } from '../../overlay/enquire';
import seamApi from '../../../lib/seam-api';
import Blurred from '../../../components/blurred';

class AvailibilityCalendar extends Component {
    constructor(props) {
        super(props);

        this.calEl = null;
    }

    setRef(r) {
        this.calEl = r;
    }

    onClickDay(date) {
        const day = dayjs(date).format('YYYY-MM-DD');

        this.props.onDaySelect(day);
    }

    isDayDisabled(date, view) {
        if (dayjs(date).isBefore(dayjs(), 'day')) return true;

        const day = dayjs(date).format('YYYY-MM-DD');

        return this.props.bookings?.hasOwnProperty(day) ? !this.props.bookings[day]?.available_for_no_requested_attendees  : false;
    }

    handleViewChange(data) {
        this.getBookings(data.activeStartDate);
    }

    render() {
        return (
            <Calendar
                className={'appointment-cal'}
                inputRef={this.setRef.bind(this)}
                tileDisabled={({ date, view }) => this.isDayDisabled(date, view)}
                onClickDay={this.onClickDay.bind(this)}
                onActiveStartDateChange={this.props.handleViewChange}
                formatDay={(local, date) => {
                        return(
                            <div className={'appointment-cal__day'}>
                                { dayjs(date).date() }
                            </div>
                        );
                }}
                value={this.props.date}
            />
        );
    }
}

AvailibilityCalendar.defaultProps = {
    relation : null,
    bookings: {},
    onChange : date => console.log(date)
};

class CoWorking extends Component {
    constructor(props) {
        super(props);

        this.state = {
            params: {
                attendees: 0,
                day: new Date(),
            },
            stats: null,
            selectedMonth: new Date(),
        }

        this.ref = createRef(null);
    }

    componentDidMount() {
        this.fetchStats();
        this.getMonthAvailability()

        if (this.ref.current) {
            handleLinks(this.ref.current, 5, this.state.params);
        }
    }

    fetchStats() {
        seamApi.coworking().getStats({
            day: this.state.params?.day,
        }).then((data) => {
            this.setState({ stats: data })
        });
    }

    getMonthAvailability() {
        seamApi.coworking().getIndexBookingMonthAvailability({
            start_of_month: datetimeLocalToString(dayjs(this.state.selectedMonth).startOf('month')),
            no_attendees: this.state.params?.attendees
        }).then(({ data }) => {
            this.setState({ spaces: data })
        })
    }

    onDaySelect(date) {
        this.onChange({ day: date });
    }

    getTimeOfDay() {
        const sessions = this.state.spaces?.[this.state?.params?.day]?.sessions_available;

        if (sessions === 'morning') {
            return [1, 0]
        }

        if (sessions === 'afternoon') {
            return [0, 1]
        }

        if (sessions === 'day') {
            return [1, 1]
        }

        return [0, 0];
    }

    onChange(obj, callback = () => {}) {
        const state = { ...this.state.params, ...obj }

        this.setState({ params: state }, callback)
    }

    onAttendeesChange(value) {
        this.onChange({
            attendees: value,
        }, () => {
            this.getMonthAvailability()
        });
    }

    handleProceed(includeParams = true) {
        const item = this.state.spaces?.[this.state?.params?.day];
        const spaces = item?.spaces;
        const space = spaces?.[0]?.space;

        let form = document.createElement('form');

        form.action = '/co-working/' + space?.id;
        form.method = 'post';

        const params = {
            'co_working_space_id': space?.id,
            'no_attendees': this.state.params?.attendees,
            'day': this.state.params?.day,
            'sessions': item?.sessions_available,
            '_token': document.querySelector('meta[name="csrf-token"]')?.content
        }

        Object.keys(params).forEach((k) => {
            let input = document.createElement('input');
            input.name = k;
            input.type = 'hidden';
            input.value = params?.[k];
            form.appendChild(input);
        })

        document.body.appendChild(form);

        form.submit();
    }

    render () {
        const [ day = 0, afternoon = 0 ] = this.getTimeOfDay();

        return (
            <div className="co-working">
                <img class="co-working__star" src="/images/assets/stars/orange-star.svg" alt=""/>
                <img class="co-working__squares" src="/images/co-working-index-squares.svg" alt=""/>

                <div className="co-working__top">
                    <Container className="co-working__availability">
                        <Container.Header>
                            <Row gap="20px">
                                <Container.Icon src="/assets/icons/trophy.svg"/>
                                <Container.Text fontSize="18px" fontWeight="600" color="#FCFCFC">Today’s availability in the DMC</Container.Text>
                            </Row>
                        </Container.Header>

                        <Container.Content>
                            <div className="availability-stats">
                                <div className="availability-stat">
                                    <div className="availability-stat__info">
                                        <h3 className="availability-stat__value">{ this.state.stats?.spaces_free_morning || 0 }</h3>
                                        <p className="availability-stat__spaces">Spaces</p>
                                    </div>
                                    <p className="availability-stat__type">Morning Session</p>
                                </div>

                                <div className="availability-stat">
                                    <div className="availability-stat__info">
                                        <h3 className="availability-stat__value">{ this.state.stats?.spaces_free_afternoon || 0 }</h3>
                                        <p className="availability-stat__spaces">Spaces</p>
                                    </div>
                                    <p className="availability-stat__type">Afternoon Session</p>
                                </div>
                            </div>
                        </Container.Content>
                    </Container>

                    <div className="co-working__description">
                        <p data-seam-tag={this.props.setupTag} dangerouslySetInnerHTML={{ __html: this.props.setup }}></p>
                    </div>
                </div>

                <div className="co-working__head">
                    <div className="co-working-head__title" data-seam-tag={this.props.titleTag}>
                        <h1>{ this.props.title }</h1>
                    </div>

                    <div className="co-working-head__description">
                        <p data-seam-tag={this.props.descriptionTag} dangerouslySetInnerHTML={{ __html: this.props.description }}></p>
                    </div>
                </div>

                <div className="co-working__main">
                    <AvailibilityCalendar
                        bookings={this.state.spaces}
                        onDaySelect={this.onDaySelect.bind(this)}
                        handleViewChange={(data) => {
                            this.setState({
                                selectedMonth: data?.activeStartDate,
                            }, () => {
                                this.getMonthAvailability();
                            })
                        }}
                    />

                    <div className="co-working__information">
                        <InputsCounter
                            label={'Number of attendees'}
                            onChange={this.onAttendeesChange.bind(this)}
                            value={this.state.params?.attendees || 0}
                        />

                        <List gap="20px">
                            <LabelContainer label="Morning Availability:" row>
                                { day === 1 ? <Container.Text color="#00C8C3" fontSize="16px">Yes</Container.Text> : 'No' }
                            </LabelContainer>

                            <LabelContainer label="Afternoon Availability:" row>
                                { afternoon === 1 ? <Container.Text color="#00C8C3" fontSize="16px">Yes</Container.Text> : 'No' }
                            </LabelContainer>
                        </List>
                    </div>

                    <div className="co-working__calendar">
                        <Blurred toggled={day === 0 && afternoon === 0}>
                            <div className="co-working__buttons">
                                <button className="meeting-booking__proceed meeting-booking__proceed--blue">
                                    <NavItem onClick={() => this.handleProceed(false)} slug="#" text="Book with myDMC" />
                                </button>

                                <button className="meeting-booking__proceed meeting-booking__proceed--green" ref={this.ref} >
                                    <NavItem slug="#co-working" text="Checkout as guest"/>
                                </button>
                            </div>
                        </Blurred>
                    </div>
                </div>
            </div>
        )
    }
}

document.addEventListener('readystatechange', () => {
    const element = document.getElementById('co-working')

    if (element) ReactDOM.render(<CoWorking
        setup={element.getAttribute('data-setup')}
        setupTag={element.getAttribute('data-setup-tag')}
        title={element.getAttribute('data-title')}
        titleTag={element.getAttribute('data-title-tag')}
        description={element.getAttribute('data-description')}
        descriptionTag={element.getAttribute('data-description-tag')}
    />, element);
});
